module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-2-fc9c3b847d805da1dd7a2f127ae28a56.png";